export default __webpack_public_path__ + "static/media/express.73f7f2d3.png";